// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery,
.e-carousel-container {
  height: 100%;
  /* max-height: 150vh;  */
  overflow-y: auto;
  border: solid 1px #ebeaea !important;
  border-radius: 10px !important;
}

.gallery-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}

.gallery-item {
  box-shadow: 0 0 15px rgba(50, 50, 50, 0.2);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  overflow: hidden;
}

.gallery-item .e-card {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.gallery-counter {
  margin-top: 10px;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/widgets/gallery/styles.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".gallery,\n.e-carousel-container {\n  height: 100%;\n  /* max-height: 150vh;  */\n  overflow-y: auto;\n  border: solid 1px #ebeaea !important;\n  border-radius: 10px !important;\n}\n\n.gallery-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px;\n}\n\n.gallery-item {\n  box-shadow: 0 0 15px rgba(50, 50, 50, 0.2);\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  overflow: hidden;\n}\n\n.gallery-item .e-card {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.gallery-counter {\n  margin-top: 10px;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
